import { Tooltip } from '@mui/material'
import { Button } from '@/@core/components/mui/Button'

export function FilterButton({ filter, onFilter }: { filter: boolean; onFilter: () => void }) {
  const { __ } = useTranslator()

  return (
    <Tooltip title='Filter'>
      <Button
        variant='tonal'
        color={filter ? 'primary' : 'secondary'}
        size='small'
        onClick={onFilter}
        startIcon={<i className={`${filter ? 'tabler-filter' : 'tabler-filter-off'}`} />}
      >
        {filter ? __('Filter On') : __('Filter Off')}
      </Button>
    </Tooltip>
  )
}
